import { ARCHIVED_BOOLEAN_FILTERS } from '@/common/api/archivedTableFilters';
import type { SkillFilterKey } from '@/common/api/types/itemFilters';

export const SKILL_BOOLEAN_FILTERS = [
  'showCriticalSkills',
] as const satisfies readonly SkillFilterKey[];

export const SKILL_FILTER_KEYS = [
  ...SKILL_BOOLEAN_FILTERS,
  ...ARCHIVED_BOOLEAN_FILTERS,
] as const satisfies readonly SkillFilterKey[];

export type SkillListFilterKey = (typeof SKILL_FILTER_KEYS)[number];

export const getSkillTableFilters = () => [...SKILL_FILTER_KEYS] as const;
